import script from "./partneredDataModel.vue?vue&type=script&setup=true&lang=js"
export * from "./partneredDataModel.vue?vue&type=script&setup=true&lang=js"

import "./partneredDataModel.vue?vue&type=style&index=0&id=4804ea28&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4804ea28"]])

export default __exports__